module.exports = __webpack_public_path__ + "img/head.f3d37357.png";